<template>
    <div v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
            <Side :step="'2'"></Side>
            <section>
                <div class="info-form" v-if="!showResult&&hasFinished">
                    <div class="box">
                        <h1 class="serviceTestTitle">eAssist Color Profile</h1>
                        <p style="margin: 10px 0">Instructions:</p>
                        <div class="mt10 fs14 lh25">Please check the one word or phrase that best describes what you were like most of the time in your earliest recollection. Choose only one response from each
                            group.
                        </div>
                        <p class="required" style="margin: 10px 0">* Required</p>
                    </div>
                    <el-form :inline="false" :rules="rules" :model="form" ref="form">
                        <div class="box">
                            <div class="subjectTest noTitle">1.</div>
                            <el-form-item prop="sub0">
                                <el-radio-group ref="sub0" v-model="form.sub0" :disabled="isAdmin">
                                    <div v-for="(item,index) in list0" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">2.</div>
                            <el-form-item prop="sub1">
                                <el-radio-group ref="sub1" v-model="form.sub1" :disabled="isAdmin">
                                    <div v-for="(item,index) in list1" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest noTitle">3.</div>
                            <el-form-item prop="sub2">
                                <el-radio-group ref="sub2" v-model="form.sub2" :disabled="isAdmin">
                                    <div v-for="(item,index) in list2" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest noTitle">4.</div>
                            <el-form-item prop="sub3">
                                <el-radio-group ref="sub3" v-model="form.sub3" :disabled="isAdmin">
                                    <div v-for="(item,index) in list3" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">5.</div>
                            <el-form-item prop="sub4">
                                <el-radio-group ref="sub4" v-model="form.sub4" :disabled="isAdmin">
                                    <div v-for="(item,index) in list4" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">6.</div>
                            <el-form-item prop="sub5">
                                <el-radio-group ref="sub5" v-model="form.sub5" :disabled="isAdmin">
                                    <div v-for="(item,index) in list5" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">7.</div>
                            <el-form-item prop="sub6">
                                <el-radio-group ref="sub6" v-model="form.sub6" :disabled="isAdmin">
                                    <div v-for="(item,index) in list6" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">8.</div>
                            <el-form-item prop="sub7">
                                <el-radio-group ref="sub7" v-model="form.sub7" :disabled="isAdmin">
                                    <div v-for="(item,index) in list7" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">9.</div>
                            <el-form-item prop="sub8">
                                <el-radio-group ref="sub8" v-model="form.sub8" :disabled="isAdmin">
                                    <div v-for="(item,index) in list8" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest noTitle">10.</div>
                            <el-form-item prop="sub9">
                                <el-radio-group ref="sub9" v-model="form.sub9" :disabled="isAdmin">
                                    <div v-for="(item,index) in list9" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">11.</div>
                            <el-form-item prop="sub10">
                                <el-radio-group ref="sub10" v-model="form.sub10" :disabled="isAdmin">
                                    <div v-for="(item,index) in list10" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">12.</div>
                            <el-form-item prop="sub11">
                                <el-radio-group ref="sub11" v-model="form.sub11" :disabled="isAdmin">
                                    <div v-for="(item,index) in list11" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">13.</div>
                            <el-form-item prop="sub12">
                                <el-radio-group ref="sub12" v-model="form.sub12" :disabled="isAdmin">
                                    <div v-for="(item,index) in list12" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">14.</div>
                            <el-form-item prop="sub13">
                                <el-radio-group ref="sub13" v-model="form.sub13" :disabled="isAdmin">
                                    <div v-for="(item,index) in list13" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">15.</div>
                            <el-form-item prop="sub14">
                                <el-radio-group ref="sub14" v-model="form.sub14" :disabled="isAdmin">
                                    <div v-for="(item,index) in list14" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">16.</div>
                            <el-form-item prop="sub15">
                                <el-radio-group ref="sub15" v-model="form.sub15" :disabled="isAdmin">
                                    <div v-for="(item,index) in list15" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">17.</div>
                            <el-form-item prop="sub16">
                                <el-radio-group ref="sub16" v-model="form.sub16" :disabled="isAdmin">
                                    <div v-for="(item,index) in list16" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">18.</div>
                            <el-form-item prop="sub17">
                                <el-radio-group ref="sub17" v-model="form.sub17" :disabled="isAdmin">
                                    <div v-for="(item,index) in list17" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">19.</div>
                            <el-form-item prop="sub18">
                                <el-radio-group ref="sub18" v-model="form.sub18" :disabled="isAdmin">
                                    <div v-for="(item,index) in list18" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">20.</div>
                            <el-form-item prop="sub19">
                                <el-radio-group ref="sub19" v-model="form.sub19" :disabled="isAdmin">
                                    <div v-for="(item,index) in list19" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">21.</div>
                            <el-form-item prop="sub20">
                                <el-radio-group ref="sub20" v-model="form.sub20" :disabled="isAdmin">
                                    <div v-for="(item,index) in list20" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">22.</div>
                            <el-form-item prop="sub21">
                                <el-radio-group ref="sub21" v-model="form.sub21" :disabled="isAdmin">
                                    <div v-for="(item,index) in list21" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">23.</div>
                            <el-form-item prop="sub22">
                                <el-radio-group ref="sub22" v-model="form.sub22" :disabled="isAdmin">
                                    <div v-for="(item,index) in list22" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">24.</div>
                            <el-form-item prop="sub23">
                                <el-radio-group ref="sub23" v-model="form.sub23" :disabled="isAdmin">
                                    <div v-for="(item,index) in list23" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">25.</div>
                            <el-form-item prop="sub24">
                                <el-radio-group ref="sub24" v-model="form.sub24" :disabled="isAdmin">
                                    <div v-for="(item,index) in list24" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">26.</div>
                            <el-form-item prop="sub25">
                                <el-radio-group ref="sub25" v-model="form.sub25" :disabled="isAdmin">
                                    <div v-for="(item,index) in list25" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">27.</div>
                            <el-form-item prop="sub26">
                                <el-radio-group ref="sub26" v-model="form.sub26" :disabled="isAdmin">
                                    <div v-for="(item,index) in list26" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">28.</div>
                            <el-form-item prop="sub27">
                                <el-radio-group ref="sub27" v-model="form.sub27" :disabled="isAdmin">
                                    <div v-for="(item,index) in list27" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">29.</div>
                            <el-form-item prop="sub28">
                                <el-radio-group ref="sub28" v-model="form.sub28" :disabled="isAdmin">
                                    <div v-for="(item,index) in list28" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest noTitle">30.</div>
                            <el-form-item prop="sub29">
                                <el-radio-group ref="sub29" v-model="form.sub29" :disabled="isAdmin">
                                    <div v-for="(item,index) in list29" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">31. If I applied for a job, a prospective employer would most likely
                                hire me because I am:</div>
                            <el-form-item prop="sub30">
                                <el-radio-group ref="sub30" v-model="form.sub30" :disabled="isAdmin">
                                    <div v-for="(item,index) in list30" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">32. When involved in an intimate relationship, if I feel threatened by my partner, I:</div>
                            <el-form-item prop="sub31">
                                <el-radio-group ref="sub31" v-model="form.sub31" :disabled="isAdmin">
                                    <div v-for="(item,index) in list31" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">33. For me, life is most meaningful when it:</div>
                            <el-form-item prop="sub32">
                                <el-radio-group ref="sub32" v-model="form.sub32" :disabled="isAdmin">
                                    <div v-for="(item,index) in list32" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">34. As a child, I was:</div>
                            <el-form-item prop="sub33">
                                <el-radio-group ref="sub33" v-model="form.sub33" :disabled="isAdmin">
                                    <div v-for="(item,index) in list33" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">35. As an adult, I am:</div>
                            <el-form-item prop="sub34">
                                <el-radio-group ref="sub34" v-model="form.sub34" :disabled="isAdmin">
                                    <div v-for="(item,index) in list34" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">36. As an adult, I am:</div>
                            <el-form-item prop="sub35">
                                <el-radio-group ref="sub35" v-model="form.sub35" :disabled="isAdmin">
                                    <div v-for="(item,index) in list35" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">37. In an argument with a friend, I am most likely to be:</div>
                            <el-form-item prop="sub36">
                                <el-radio-group ref="sub36" v-model="form.sub36" :disabled="isAdmin">
                                    <div v-for="(item,index) in list36" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">38. If my friend was in trouble, I would be:</div>
                            <el-form-item prop="sub37">
                                <el-radio-group ref="sub37" v-model="form.sub37" :disabled="isAdmin">
                                    <div v-for="(item,index) in list37" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">39. In an argument with a friend, I am most likely to be:</div>
                            <el-form-item prop="sub38">
                                <el-radio-group ref="sub38" v-model="form.sub38" :disabled="isAdmin">
                                    <div v-for="(item,index) in list38" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">40. When I fail, I feel:</div>
                            <el-form-item prop="sub39">
                                <el-radio-group ref="sub39" v-model="form.sub39" :disabled="isAdmin">
                                    <div v-for="(item,index) in list39" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">41.If someone crosses me:</div>
                            <el-form-item prop="sub40">
                                <el-radio-group ref="sub40" v-model="form.sub40" :disabled="isAdmin">
                                    <div v-for="(item,index) in list40" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">42. Work is:</div>
                            <el-form-item prop="sub41">
                                <el-radio-group ref="sub41" v-model="form.sub41" :disabled="isAdmin">
                                    <div v-for="(item,index) in list41" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">43. In social situations, I am most often:</div>
                            <el-form-item prop="sub42">
                                <el-radio-group ref="sub42" v-model="form.sub42" :disabled="isAdmin">
                                    <div v-for="(item,index) in list42" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">44. In a relationship, I am most concerned with being:</div>
                            <el-form-item prop="sub43">
                                <el-radio-group ref="sub43" v-model="form.sub43" :disabled="isAdmin">
                                    <div v-for="(item,index) in list43" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest">45. To feel alive and positive, I seek:</div>
                            <el-form-item prop="sub44">
                                <el-radio-group ref="sub44" v-model="form.sub44" :disabled="isAdmin">
                                    <div v-for="(item,index) in list44" :key="index">
                                        <el-radio :label="item.value">{{item.key}}</el-radio><br>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                    <div class="btnLayout">
                        <el-button class="yellowBtn" @click="submit" v-if="!isAdmin">Submit</el-button>
                        <el-button class="grayBtn" @click="cancel">Cancel</el-button>
                    </div>
                    </el-form>
                </div>
                <div  v-if="showResult">
                    <ColorChart :colors="colors" ref="colorChart"/>
                    <el-button class="yellowBtn" style="margin-top: 20px;width: 80px" @click="goPre">Back</el-button>
                </div>
            </section>
        </div>
        <el-dialog title="warning" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goPre">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Confirm" :visible.sync="confirmVisible">
            <div>Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="confirmForm">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
    import ApplyHeader from "../../components/ApplyHeader"
    import Side from '../../components/Aside.vue'
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
    import ColorChart from "./colorChart"
    import { chat2Ascii } from "../../../static/js/util"
    export default {
        name: "colorTest",
        components:{ApplyHeader,Side,ColorChart},
        data(){
            return{
                list0:[{key:'Opinionated',value:0},{key:'Nurturing',value:1},{key:'Inventive',value:2},{key:'Outgoing',value:3}],
                list1:[{key:'Power-oriented',value:0},{key:'A perfectionist',value:1},{key:'Indecisive',value:2},{key:'Self-Centered',value:3}],
                list2:[{key:'Dominant',value:0},{key:'Sympathetic',value:1},{key:'Tolerant',value:2},{key:'Enthusiastic',value:3}],
                list3:[{key:'Self-serving',value:0},{key:'Suspicious',value:1},{key:'Unsure',value:2},{key:'Naive',value:3}],
                list4:[{key:'Decisive',value:0},{key:'Loyal',value:1},{key:'Contented',value:2},{key:'Playful',value:3}],
                list5:[{key:'Arrogant',value:0},{key:'Worry-prone',value:1},{key:'Silently stubborn',value:2},{key:'Flighty',value:3}],
                list6:[{key:'Assertive',value:0},{key:'Reliable',value:1},{key:'Kind',value:2},{key:'Sociable',value:3}],
                list7:[{key:'Bossy',value:0},{key:'Self-critical',value:1},{key:'Reluctant',value:2},{key:'A teaser',value:3}],
                list8:[{key:'Action-oriented',value:0},{key:'Analytical',value:1},{key:'Easygoing',value:2},{key:'Carefree',value:3}],
                list9:[{key:'Critical of others',value:0},{key:'Overly sensitive',value:1},{key:'Shy',value:2},{key:'Obnoxious',value:3}],
                list10:[{key:'Determined',value:0},{key:'Detail conscious',value:1},{key:'A good listener',value:2},{key:'A party person',value:3}],
                list11:[{key:'Demanding',value:0},{key:'Unforgiving',value:1},{key:'Unmotivated',value:2},{key:'Vain',value:3}],
                list12:[{key:'Responsible',value:0},{key:'Idealistic',value:1},{key:'Considerate',value:2},{key:'Happy',value:3}],
                list13:[{key:'Impatient',value:0},{key:'Moody',value:1},{key:'Passive',value:2},{key:'Impulsive',value:3}],
                list14:[{key:'Strong-willed',value:0},{key:'Respectful',value:1},{key:'Patient',value:2},{key:'Fun-loving',value:3}],
                list15:[{key:'Argumentative',value:0},{key:'Unrealistic',value:1},{key:'Directionless',value:2},{key:'An interrupter',value:3}],
                list16:[{key:'Independent',value:0},{key:'Dependable',value:1},{key:'Even-Tempered',value:2},{key:'Trusting',value:3}],
                list17:[{key:'Aggressive',value:0},{key:'Frequently depressed',value:1},{key:'Ambivalent',value:2},{key:'Forgetful',value:3}],
                list18:[{key:'Powerful',value:0},{key:'Deliberate',value:1},{key:'Gentle',value:2},{key:'Optimistic',value:3}],
                list19:[{key:'Insensitive',value:0},{key:'Judgmental',value:1},{key:'Boring',value:2},{key:'Undisciplined',value:3}],
                list20:[{key:'Logical',value:0},{key:'Emotional',value:1},{key:'Agreeable',value:2},{key:'Popular',value:3}],
                list21:[{key:'Always right',value:0},{key:'Guilt prone',value:1},{key:'Unenthusiastic',value:2},{key:'Uncommitted',value:3}],
                list22:[{key:'Pragmatic',value:0},{key:'Well-behaved',value:1},{key:'Accepting',value:2},{key:'Spontaneous',value:3}],
                list23:[{key:'Merciless',value:0},{key:'Thoughtful',value:1},{key:'Uninvolved',value:2},{key:'A show-off',value:3}],
                list24:[{key:'Task-oriented',value:0},{key:'Sincere',value:1},{key:'Diplomatic',value:2},{key:'Lively',value:3}],
                list25:[{key:'Tactless',value:0},{key:'Hard to please',value:1},{key:'Lazy',value:2},{key:'Loud',value:3}],
                list26:[{key:'Direct',value:0},{key:'Creative',value:1},{key:'Adaptable',value:2},{key:'A performer',value:3}],
                list27:[{key:'Calculating',value:0},{key:'Self-righteous',value:1},{key:'Self-deprecating',value:2},{key:'Disorganized',value:3}],
                list28:[{key:'Confident',value:0},{key:'Disciplined',value:1},{key:'Pleasant',value:2},{key:'Charismatic',value:3}],
                list29:[{key:'Intimidating',value:0},{key:'Careful',value:1},{key:'Unproductive',value:2},{key:'Afraid to face facts',value:3}],
                list30:[{key:'Driven, direct, and delegating.',value:0},{key:'Deliberate, accurate, and reliable.',value:1},{key:'Patient, adaptable, and tactful.',value:2},{key:'Fun-loving, spirited, and casual.',value:3}],
                list31:[{key:'Fight back with facts and anger',value:0},{key:'Cry, feel hurt, and plan revenge',value:1},
                    {key:'Become quiet, withdrawn, and often hold anger until I blow up over some minor issue later',value:2},{key:'Distance myself and avoid further conflict.',value:3}],
                list32:[{key:'Is task-oriented and productive.',value:0},{key:'Is filled with people and purpose.',value:1},
                    {key:'Is free of pressure and stress.',value:2},{key:'Allows me to be playful, lighthearted, and optimistic.',value:3}],
                list33:[{key:'Stubborn, bright, and/or aggressive.',value:0},{key:'Well behaved, caring, and/or depressed.',value:1},
                    {key:'Quiet, easygoing, and/or shy.',value:2},{key:'Too talkative, happy, and/or playful.',value:3}],
                list34:[{key:'Opinionated, determined, and/or bossy.',value:0},{key:'Responsible, honest, and/or unforgiving.',value:1},
                    {key:'Accepting, contented, and/or unmotivated.',value:2},{key:'Charismatic, positive, and/or obnoxious.',value:3}],
                list35:[{key:'Demanding, quick-tempered, and / or uncompromising.',value:0},{key:'Concerned, sensitive, and / or critical.',value:1},
                    {key:'Permissive, easily persuaded, and / or often overwhelmed.',value:2},{key:'Playful, casual, and / or irresponsible.',value:3}],
                list36:[{key:'Verbally stubborn about facts.',value:0},{key:"Concerned about others' feelings and principles.",value:1},
                    {key:'Silently stubborn, uncomfortable, and / or confused.',value:2},{key:'Loud, uncomfortable, and / or compromising.',value:3}],
                list37:[{key:'Protective, resourceful, and recommending solutions.',value:0},{key:'Concerned, empathetic, and loyal -- regardless of the problem.',value:1},
                    {key:'Supportive, patient, and a good listener.',value:2},{key:'Nonjudgmental, optimistic, and downplaying the seriousness of the situation.',value:3}],
                list38:[{key:'Assertive, articulate, and logical.',value:0},{key:'Deliberate, precise, and cautious.',value:1},
                    {key:'Indecisive, timid, and reluctant.',value:2},{key:'Impulsive, uncommitted, and inconsistent.',value:3}],
                list39:[{key:'Silently self-critical, yet verbally stubborn and defensive.',value:0},{key:'Guilty, self-critical, and vulnerable to depression -- I dwell on it.',value:1},
                    {key:'Unsettled and fearful, but I keep it to myself.',value:2},{key:'Embarrassed and nervous -- seeking to escape the situation.',value:3}],
                list40:[{key:'I am angered and cunningly plan ways to get even quickly.',value:0},{key:'I feel deeply hurt and find it almost impossible to forgive completely. Generally, getting even is not enough.',value:1},
                    {key:'I am silently hurt and plan to get even and / or completely avoid the other person.',value:2},{key:'I want to avoid confrontation, consider the situation not important enough to bother with, and / or seek other friends.',value:3}],
                list41:[{key:"A most productive way to spend one's time.",value:0},{key:"A healthy activity, which should be done right if it's to be done at all. Work should be done before one plays.",value:1},
                    {key:"A positive activity as long as it is something I enjoy and don't feel pressured to accomplish.",value:2},{key:'A necessary evil, much less inviting than play.',value:3}],
                list42:[{key:'Feared by others.',value:0},{key:'Admired by others.',value:1},{key:'Protected by others.',value:2},{key:'Envied by others.',value:3}],
                list43:[{key:'Approved of and right.',value:0},{key:'Understood, appreciated, and intimate.',value:1},
                    {key:'Respected, tolerant, and peaceful.',value:2},{key:'Praised, having fun, and feeling free.',value:3}],
                list44:[{key:'Adventure, leadership, and lots of actions.',value:0},{key:'Security, creativity, and purpose.',value:1},
                    {key:'Acceptance and safety.',value:2},{key:'Excitement, playful productivity, and the company of others.',value:3}],

                ChartIsView:false,
                wrong:wrong,
                right:right,
                //题目
                subject:{},
                exitVisible:false,
                confirmVisible:false,
                showResult:false,
                hasFinished:false,//代表页面初始化完毕,比如是显示做题结果结果还是显示题目
                smallScreen:false,
                correctNum:0,
                totalNum:34,
                form:{},
                colors:[0,0,0,0],
                loading:false,
                isAdmin:false,
                /**表单验证规则，所有选项都不允许为空  第10题和第26题如果一个都没有选也会提示**/
                rules: {
                    sub0: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub1: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub2: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub3: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub4: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub5: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub6: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub7: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub8: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub9: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub10: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub11: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub12: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub13: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub14: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub15: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub16: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub17: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub18: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub19: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub20: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub21: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub22: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub23: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub24: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub25: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub26: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub27: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub28: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub29: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub30: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub31: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub32: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub33: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub34: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub35: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub36: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub37: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub38: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub39: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub40: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub41: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub42: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub43: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub44: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],

                },
                correctAnswer0:'40/40.00/$40/$40.00',
                correctAnswer1:'643/643.00/$643/$643.00'
            }
        },
        created() {
            var clientW = document.documentElement.clientWidth
            if(clientW<1220){
                this.smallScreen=true
            }
            this.getData()
        },
        computed:{
            getHeight(){
                return document.documentElement.clientHeight
            },
        },
        methods:{
            resortOption(){//产生测试数据函数
                for(var i =0;i<45;i++){
                    this['list'+i] = this.rand(this['list'+i])
                    console.log('list'+i,this['list'+i])
                }
            },
            rand(arr) {
                var len = arr.length
                //首先从最大的数开始遍历，之后递减
                for(var i = len - 1; i >= 0; i--) {
                    //随机索引值randomIndex是从0-arr.length中随机抽取的
                    var randomIndex = Math.floor(Math.random() * (i + 1));
                    //下面三句相当于把从数组中随机抽取到的值与当前遍历的值互换位置
                    var itemIndex = arr[randomIndex];
                    arr[randomIndex] = arr[i];
                    arr[i] = itemIndex;
                }
                //每一次的遍历都相当于把从数组中随机抽取（不重复）的一个元素放到数组的最后面（索引顺序为：len-1,len-2,len-3......0）
                return arr;
            },
            addColors(){
                for(var i=0;i<45;i++){
                    this.colorAdd(this.form['sub'+i])
                }
            },
            confirmForm(){
                this.colors = [0,0,0,0]
                this.addColors();
                var params = {}
                params.email=localStorage.getItem('email')
                params.red = this.colors[0];
                params.blue = this.colors[1];
                params.white = this.colors[2];
                params.yellow = this.colors[3];
                this.ChartIsView = true;
                this.showResult= true
                console.log('提交的参数',params)
                this.confirmVisible = false;
                this.loading=true
                this.$axios.post(this.$URL.colorTestUrl,params).then(res=>{
                    this.loading = false
                    if(res&&res.code===0){
                        console.log(res)
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
                console.log(params)
            },
            colorAdd(color){
                if(color == 0){
                    this.colors[0]++
                }else if(color == 1){
                    this.colors[1]++
                }
                else if(color == 2){
                    this.colors[2]++
                }
                else if(color == 3){
                    this.colors[3]++
                }
            },
            goPre(){
                this.$router.go(-1)
            },
            cancel(){
                this.exitVisible=true
            },
            submit(){
                console.log('提交信息',this.form)
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                    this.$refs['form'].validate((valid,object) => {
                        if (valid) {
                            this.confirmVisible = true;
                        }else {
                            var obj = Object.keys(object)[0]
                            let dom = this.$refs[obj]
                            dom.$el.scrollIntoView({
                                //滚动到指定节点
                                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                            })
                            console.log('error submit!!');
                            return false;
                        }
                    })
                })
            },
            getData(){
                this.resortOption()
                if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify){

                    this.isAdmin = true
                    this.showResult=true
                }else{
                    this.isAdmin = false
                }
                this.getColorTestData()
            },
            getColorTestData(){
                console.log('getColorTestData')
                var email=''
                if(this.$route&&this.$route.query.model=='review'&&this.$route.query.verify){
                     email = this.$route.query.email
                     var verify = this.$route.query.verify
                    var verifyCode = chat2Ascii(email)
                    if(verifyCode!=verify){
                         this.$router.push('/login')
                        return
                    }
                    this.isAdmin=true
                }else{
                    email = localStorage.getItem('email')
                }
                this.loading=true
                this.$axios.get(this.$URL.colorTestUrl,{params:{email:email}}).then(res=>{
                    this.loading=false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        var data = res.data
                        if(data){
                            this.showResult=true
                            this.colors[0]=data.red||0
                            this.colors[1]=data.blue||0
                            this.colors[2]=data.white||0
                            this.colors[3]=data.yellow||0
                            if(this.$refs&&this.$refs.colorChart)this.$refs.colorChart.update()
                        }
                        console.log('colors',this.colors)
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
        },
        watch:{
            '$route'(to,from){
                console.log(from.path)
                if(to.path==='/colorTest'){
                    this.getData()
                }
            },
        }
    }
</script>

<style scoped>
    .btnLayout{
        margin:10px 0 20px 15px
    }
    .rightPic{
        width: 20px;
        position: absolute;
        right: 20px
    }
    .el-radio{
        width:200px;
        height:43px;
        line-height:20px!important;
    }
    .radioText{
        display: inline-block;
    }
    .box>>>.el-radio__label{
        vertical-align: middle!important;
    }
    .noTitle{
        float: left;
        width: 25px;
    }
    .charts{
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        background: #FFFFFF;
        border-radius: 2px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
        box-sizing: border-box;
        width: 80%;
    }
    @media screen and (max-width: 1440px) {
        .btnLayout{
            margin:10px 0 20px 5px
        }
    }
    @media screen and (max-width: 1200px) {
        .btnLayout{
            margin:10px 0 20px 0px
        }
    }
</style>
